const validateImage = async ({
  content,
  maxSize,
  setImgErrorMessage,
  setDisplayImgUploadError,
  showErrorMessage,
  allowImg,
  idealImageSize,
  reduceImageResolution,
  compressMaxSize,
  getBase64,
}) => {
  let errorMessage = ''
  let fileSize = content.size
  let image

  if (content.size > maxSize) {
    setImgErrorMessage('File size exceeds 100 MB.')
    setDisplayImgUploadError(true)
    showErrorMessage()
    return {
      fileSize,
      image: null,
      errorMessage: 'Maximum file size exceeds',
    }
  }

  const ext = content.type.split('/').pop().toLowerCase()
  if (!allowImg.includes(ext)) {
    setImgErrorMessage('Please upload JPG, JPEG, PNG, BMP, or GIF images.')
    setDisplayImgUploadError(true)
    showErrorMessage()
    return {
      fileSize,
      image: null,
      errorMessage: 'Image extension not allowed',
    }
  }

  // Reduce image if more than the ideal image size
  if (content.size > idealImageSize) {
    image = await reduceImageResolution(content)
    const decoded = atob(image)
    fileSize = decoded.length
    if (fileSize > compressMaxSize) {
      setImgErrorMessage('File size exceeds 12 MB.')
      setDisplayImgUploadError(true)
      showErrorMessage()
      errorMessage = 'Maximum file size exceeds'
    }
  } else {
    image = await getBase64(content)
  }
  return {
    image,
    errorMessage,
    fileSize,
  }
}

export default validateImage
